import { useContext } from "react";
import { FarmContext } from "~/context/FarmContext";

export function useFarm() {
  return useContext(FarmContext)
}